import classNames, { Value as ClassValue } from "classnames";
import React, { CSSProperties } from "react";
import { isNodeEmpty } from "Tools";

export function ControlWrapper(props: {
  className?: ClassValue;
  style?: CSSProperties;
  leftIconContent?: React.ReactNode;
  rightIconContent?: React.ReactNode;
  errorMessage?: React.ReactNode;
  children?: React.ReactNode;
}) {
  const iconStyle = {
    width: "initial",
    height: "initial",
    minWidth: "2.25em",
    minHeight: "2.25em",
  };
  return (
    <div
      className={classNames("control", props.className, {
        "has-icons-left": !isNodeEmpty(props.leftIconContent),
        "has-icons-right": !isNodeEmpty(props.rightIconContent),
        "has-text-right":
          isNodeEmpty(props.leftIconContent) &&
          !isNodeEmpty(props.rightIconContent),
      })}
      style={props.style}
    >
      {props.children}
      {!isNodeEmpty(props.leftIconContent) && (
        <span className="icon is-left" style={iconStyle}>
          {props.leftIconContent}
        </span>
      )}
      {!isNodeEmpty(props.rightIconContent) && (
        <span className="icon is-right" style={iconStyle}>
          {props.rightIconContent}
        </span>
      )}
      {props.errorMessage}
    </div>
  );
}
